import LayoutCheckoutView from './layout-checkout-view'

export default LayoutCheckoutView
